import angular from "angular"

FormularioCrearUsuarioController.$inject = ["$scope", "$mdDialog", "GroupService", "saveCallback"]
function FormularioCrearUsuarioController($scope, $mdDialog, GroupService, saveCallback) {
  var self = $scope

  self.isLoading = false

  GroupService.get().$promise.then(function(data) {
    self.roles = data.results
  })

  self.confirm = function() {
    var user = {
      first_name: self.first_name,
      last_name: self.last_name,
      username: self.username,
      email: self.email,
      password: self.password,
      rol_id: self.rol_id
    }

    // console.log(user);
    saveCallback(user)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

angular
  .module("appModule")
  .controller("FormularioCrearUsuarioController", FormularioCrearUsuarioController)
